import { configureStore } from "@reduxjs/toolkit";
import formFieldReducer from "../redux/slice/form-field/formFieldSlice.js";
import searchProvidersReducer from "../redux/slice/provider-search/searchProvidersSlice.js";

export default configureStore({
  reducer: {
    formField: formFieldReducer,
    searchProviders: searchProvidersReducer,
  },
});
